import { APP_VERSION } from "@/versionInfo";
import http from "@/Service/http-common";

const LAST_CHECKED_AT_KEY = "clipn:lastVersionCheckAt";
const PENDING_VERSION_KEY = "clipn:pendingVersion";

const safeParseJson = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

export const buildSupportSnapshot = () => {
  const pendingVersionRaw = window.localStorage.getItem(PENDING_VERSION_KEY);
  const pendingVersion = safeParseJson(pendingVersionRaw);
  const lastVersionCheckTime = window.localStorage.getItem(LAST_CHECKED_AT_KEY);
  const apiBaseUrl =
    http?.defaults?.baseURL || (typeof window !== "undefined" ? window.location.origin : "unknown");

  const payload = {
    timestamp: new Date().toISOString(),
    frontendVersion: APP_VERSION.version,
    commitSha: APP_VERSION.commitSha,
    buildTime: APP_VERSION.buildTime,
    apiBaseUrl,
    lastVersionCheckTime: lastVersionCheckTime || "unknown",
    pendingVersion: pendingVersion?.version || "none",
    pendingVersionBuildTime: pendingVersion?.buildTime || null,
    userAgent: navigator.userAgent,
    platform: navigator.platform || "unknown",
    language: navigator.language || "unknown",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "unknown",
  };

  return payload;
};

export const buildSupportSnapshotText = () => {
  const snapshot = buildSupportSnapshot();
  return `ClipN Support Snapshot\n${JSON.stringify(snapshot, null, 2)}`;
};

